// Generated by purs version 0.15.16
var BrowserLocationChanged = /* #__PURE__ */ (function () {
    function BrowserLocationChanged(value0) {
        this.value0 = value0;
    };
    BrowserLocationChanged.create = function (value0) {
        return new BrowserLocationChanged(value0);
    };
    return BrowserLocationChanged;
})();
var HydratedLocation = /* #__PURE__ */ (function () {
    function HydratedLocation(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    };
    HydratedLocation.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return new HydratedLocation(value0, value1, value2);
            };
        };
    };
    return HydratedLocation;
})();
var Step1Msg = /* #__PURE__ */ (function () {
    function Step1Msg(value0) {
        this.value0 = value0;
    };
    Step1Msg.create = function (value0) {
        return new Step1Msg(value0);
    };
    return Step1Msg;
})();
var Step1SearchDebounced = /* #__PURE__ */ (function () {
    function Step1SearchDebounced(value0) {
        this.value0 = value0;
    };
    Step1SearchDebounced.create = function (value0) {
        return new Step1SearchDebounced(value0);
    };
    return Step1SearchDebounced;
})();
var Step1InitialLoaded = /* #__PURE__ */ (function () {
    function Step1InitialLoaded(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Step1InitialLoaded.create = function (value0) {
        return function (value1) {
            return new Step1InitialLoaded(value0, value1);
        };
    };
    return Step1InitialLoaded;
})();
var Step1RecentFormsLoaded = /* #__PURE__ */ (function () {
    function Step1RecentFormsLoaded(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Step1RecentFormsLoaded.create = function (value0) {
        return function (value1) {
            return new Step1RecentFormsLoaded(value0, value1);
        };
    };
    return Step1RecentFormsLoaded;
})();
var Step1FormOrderSaved = /* #__PURE__ */ (function () {
    function Step1FormOrderSaved(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Step1FormOrderSaved.create = function (value0) {
        return function (value1) {
            return new Step1FormOrderSaved(value0, value1);
        };
    };
    return Step1FormOrderSaved;
})();
var Step1LocksToggled = /* #__PURE__ */ (function () {
    function Step1LocksToggled(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Step1LocksToggled.create = function (value0) {
        return function (value1) {
            return new Step1LocksToggled(value0, value1);
        };
    };
    return Step1LocksToggled;
})();
var Step1DocumentsCopied = /* #__PURE__ */ (function () {
    function Step1DocumentsCopied(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Step1DocumentsCopied.create = function (value0) {
        return function (value1) {
            return new Step1DocumentsCopied(value0, value1);
        };
    };
    return Step1DocumentsCopied;
})();
var Step1DocumentsDeleted = /* #__PURE__ */ (function () {
    function Step1DocumentsDeleted(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Step1DocumentsDeleted.create = function (value0) {
        return function (value1) {
            return new Step1DocumentsDeleted(value0, value1);
        };
    };
    return Step1DocumentsDeleted;
})();
var Step1DocumentsExported = /* #__PURE__ */ (function () {
    function Step1DocumentsExported(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    };
    Step1DocumentsExported.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return new Step1DocumentsExported(value0, value1, value2);
            };
        };
    };
    return Step1DocumentsExported;
})();
var Step1SignaturesRequested = /* #__PURE__ */ (function () {
    function Step1SignaturesRequested(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Step1SignaturesRequested.create = function (value0) {
        return function (value1) {
            return new Step1SignaturesRequested(value0, value1);
        };
    };
    return Step1SignaturesRequested;
})();
var Step1FormsUpdated = /* #__PURE__ */ (function () {
    function Step1FormsUpdated(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    };
    Step1FormsUpdated.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return new Step1FormsUpdated(value0, value1, value2);
            };
        };
    };
    return Step1FormsUpdated;
})();
var Step2AAction = /* #__PURE__ */ (function () {
    function Step2AAction(value0) {
        this.value0 = value0;
    };
    Step2AAction.create = function (value0) {
        return new Step2AAction(value0);
    };
    return Step2AAction;
})();
var Step2AInitialLoaded = /* #__PURE__ */ (function () {
    function Step2AInitialLoaded(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Step2AInitialLoaded.create = function (value0) {
        return function (value1) {
            return new Step2AInitialLoaded(value0, value1);
        };
    };
    return Step2AInitialLoaded;
})();
var Step2BAction = /* #__PURE__ */ (function () {
    function Step2BAction(value0) {
        this.value0 = value0;
    };
    Step2BAction.create = function (value0) {
        return new Step2BAction(value0);
    };
    return Step2BAction;
})();
var Step2BLoaded = /* #__PURE__ */ (function () {
    function Step2BLoaded(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Step2BLoaded.create = function (value0) {
        return function (value1) {
            return new Step2BLoaded(value0, value1);
        };
    };
    return Step2BLoaded;
})();
var Step2FormsExported = /* #__PURE__ */ (function () {
    function Step2FormsExported(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Step2FormsExported.create = function (value0) {
        return function (value1) {
            return new Step2FormsExported(value0, value1);
        };
    };
    return Step2FormsExported;
})();
var Step3Msg = /* #__PURE__ */ (function () {
    function Step3Msg(value0) {
        this.value0 = value0;
    };
    Step3Msg.create = function (value0) {
        return new Step3Msg(value0);
    };
    return Step3Msg;
})();
var Step3DocumentRequestHandled = /* #__PURE__ */ (function () {
    function Step3DocumentRequestHandled() {

    };
    Step3DocumentRequestHandled.value = new Step3DocumentRequestHandled();
    return Step3DocumentRequestHandled;
})();
var Step3FormTypesLoaded = /* #__PURE__ */ (function () {
    function Step3FormTypesLoaded(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Step3FormTypesLoaded.create = function (value0) {
        return function (value1) {
            return new Step3FormTypesLoaded(value0, value1);
        };
    };
    return Step3FormTypesLoaded;
})();
var Step3InitialLoaded = /* #__PURE__ */ (function () {
    function Step3InitialLoaded(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Step3InitialLoaded.create = function (value0) {
        return function (value1) {
            return new Step3InitialLoaded(value0, value1);
        };
    };
    return Step3InitialLoaded;
})();
var OpStarted = /* #__PURE__ */ (function () {
    function OpStarted(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    };
    OpStarted.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return new OpStarted(value0, value1, value2);
            };
        };
    };
    return OpStarted;
})();
var OpCompleted = /* #__PURE__ */ (function () {
    function OpCompleted(value0) {
        this.value0 = value0;
    };
    OpCompleted.create = function (value0) {
        return new OpCompleted(value0);
    };
    return OpCompleted;
})();
var OpFailed = /* #__PURE__ */ (function () {
    function OpFailed(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    OpFailed.create = function (value0) {
        return function (value1) {
            return new OpFailed(value0, value1);
        };
    };
    return OpFailed;
})();
var OpSuperseded = /* #__PURE__ */ (function () {
    function OpSuperseded(value0) {
        this.value0 = value0;
    };
    OpSuperseded.create = function (value0) {
        return new OpSuperseded(value0);
    };
    return OpSuperseded;
})();
export {
    BrowserLocationChanged,
    HydratedLocation,
    Step1Msg,
    Step1SearchDebounced,
    Step1InitialLoaded,
    Step1RecentFormsLoaded,
    Step1FormOrderSaved,
    Step1LocksToggled,
    Step1DocumentsCopied,
    Step1DocumentsDeleted,
    Step1DocumentsExported,
    Step1SignaturesRequested,
    Step1FormsUpdated,
    Step2AAction,
    Step2AInitialLoaded,
    Step2BAction,
    Step2BLoaded,
    Step2FormsExported,
    Step3Msg,
    Step3DocumentRequestHandled,
    Step3FormTypesLoaded,
    Step3InitialLoaded,
    OpStarted,
    OpCompleted,
    OpFailed,
    OpSuperseded
};
//# sourceMappingURL=index.js.map
